import { ILCChangeCandidate } from '../interfaces/ILCChangeCandidate';
import { ILCChangeParty } from '../interfaces/ILCChangeParty';
import { ILCStaticParty } from '../interfaces/ILCStaticParty';


export class LCPartyCount {

  private readonly _lcStaticParty: ILCStaticParty;
  private readonly _lcChangeParty: ILCChangeParty;

  private totalVotesValue = 0;

  constructor(lcStaticParty: ILCStaticParty, lcChangeParty: ILCChangeParty, totalVotes: number) {
    this._lcStaticParty = lcStaticParty;
    this._lcChangeParty = lcChangeParty;
    this.totalVotesValue = totalVotes;
  }


  public afterInit(): void {


      // calc totals here
  }


  // Note 1.: The indicative quota is calculated by dividing the total number of formal votes counted so far by 12 and then
  // adding 1 to the result. e.g. If 250,000 formal votes have been counted so far, the indicative quota will
  // be: (250,000 / 12) + 1 = 20,834. A party that has won 52,000 first preference votes so far, will have won 2.5 quotas.
  // A party that has won 19,000 first preference votes so far, will have won 0.9 quotas.

  // Note 2.: The final quota is calculated in exactly the same way, but using all formal votes cast at the election.
  // e.g. At the 2018 State Election, there were 1,050,874 formal votes. The final quota was therefore 87,573 which was
  // calculated as follows: (1,050,874 / 12) + 1 = 87,573.

  public get votes(): number {
    return this._lcChangeParty.votes;
  }

  public get quotaVotes(): number | null {
    return this.totalVotesValue > 0 ? (this.totalVotesValue / 12) + 1 : null;
  }

  public get quotaPercent(): number {
    const q = this.quotaVotes;
    if (q == null || q === 0) return 0;
    const value = Number((this.votes / q).toFixed(2));
    return Number.isFinite(value) ? value : 0;
  }

  public get partyShare(): number {
    return this.totalVotesValue > 0 ? (this.votes / this.totalVotesValue) * 100 : 0;
  }

  public get partyName(): string {
    return this._lcStaticParty.partyName;
  }

  public get colourCode(): string {
    return this._lcStaticParty.colourCode;
  }

  public get id(): number {
    return this._lcStaticParty.id;
  }

  public get partyId(): string {
    return this._lcStaticParty.partyId;
  }

  public get seatsWon(): number {
    return this._lcChangeParty.seats;
  }

  public get candidates(): ILCChangeCandidate[] {
    return this._lcChangeParty.candidates;
  }

}
